import React from "react";
import PropTypes from "prop-types";
import Card from "../card/Card";
import List from "../list/List";
import ListItem from "../list-item/ListItem";

const ContractHolder = (props) => {
    const { direction, contractHolderData } = props;

    const formatPhoneNumber = (phoneNumberString) => {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        const match = cleaned.match(/^(\d{1,3})(\d{0,3})(\d{0,4})(\d{0,4})$/);
        if (match) {
            cleaned = `(${match[1]}${match[2] ? ') ' : ''}${match[2]}${match[3] ? '-' : ''}${match[3]}${match[4] ? ' x' : ''}${match[4]}`;
        }
        return cleaned;
    }

    const displayData = () => {
        if (contractHolderData) {
            return (
                <div className="card-container">
                    <Card cardTitle="Contract Holder" cardIcon="fas fa-file-contract">
                        <div className={`d-flex pl-31 flex-wrap flex-${direction}`}>
                            <List>
                                <div className="card-col__1 mt-9">
                                    <ListItem itemKey="Name" itemValue={contractHolderData.name} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Phone" itemValue={formatPhoneNumber(contractHolderData.phoneNumber)} />
                                </div>
                                <div className="card-col__1 mt-11">
                                    <ListItem itemKey="Email" itemValue={contractHolderData.email} />
                                </div>
                            </List>
                        </div>
                    </Card>
                </div>
            )
        }
    }

    return (
        <React.Fragment>
            {displayData()}
        </React.Fragment>
    )
};

ContractHolder.propTypes = {
    direction: PropTypes.string,
    contractHolderData: PropTypes.object
}

export default ContractHolder;